export default "__VITE_ASSET__hGo6XeqX__"